import { StanbridgeOnly } from '@/middleware/EdverumClientMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import { canViewStudentSupportDashboard } from '@/policies/StudentSupportDashboardPolicy.js';

export default [
    {
        path: '/dashboards/student-support',
        component: () => import('@/pages/student-support/StudentSupportDashboard.vue'),
        beforeEnter: [StanbridgeOnly],
        meta: {
            title: 'Student Support Dashboard',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper }) => canViewStudentSupportDashboard(gateKeeper.user),
            dataTablePage: true,
        },
        children: [
            {
                path: '',
                name: 'student-support',
                component: () => import('@/components/edverum-insights/dashboard/AtRiskStudents.vue'),
                props: { canManageInterventions: true },
            },
            {
                path: 'cases',
                name: 'student-support-cases',
                component: () => import('@/components/edverum-insights/dashboard/InterventionCases.vue'),
            },
            {
                path: 'cases/:caseId(\\d+)',
                name: 'student-support-case',
                component: () => import('@/components/edverum-insights/dashboard/InterventionCases.vue'),
            },
            {
                path: 'cohort-assignments',
                name: 'student-support-cohort-assignments',
                component: () => import('@/pages/edverum-insights/CohortAssignments.vue'),
            },
        ],
    },
    {
        path: '/dashboards/insights/cohort-assignments',
        name: 'insights-cohort-assignments',
        redirect: to => ({ name: 'student-support-cohort-assignments', query: to.query, hash: to.hash }),
    },
];
